import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        gap: tokens.spacingHorizontalM,
        alignItems: 'center',
    },
});
